import { render } from "./OrdersView.vue?vue&type=template&id=6166f96f&scoped=true"
import script from "./OrdersView.vue?vue&type=script&lang=js"
export * from "./OrdersView.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6166f96f"

export default script